import {Chip} from '@mui/material';
import {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import AddPatientScheule from '../../Components/AddPatientScheule';
import useInPatient from '../../hooks/useInPatient';
import '../../styles/Patients.scss';
import {formatDate, formatTime} from '../../utils/dateTime';
import Actions from './Actions';
import Filters from './Filters';
import InPatientTable from './InPatientTable';
import PageHeader from './PageHeader';

const InPatientSchedule = ({loaderchange, popupalert, popuptext}) => {
  const [filters, setFilters] = useState({search: ''});
  const [pagination, setPagination] = useState({pageIndex: 1, pageSize: 10});
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  const {procedures, hospitals, dataCount} = useInPatient(filters, pagination, loaderchange, popupalert, popuptext);

  const sideactive = useSelector(state => state.counter.sidebarnav);
  const inpatient = useSelector(state => state.inPatientSchedule.inpatient);

  const handleCreateDrugInventory = () => {
    setEditData(null); // Reset edit data when creating new entry
    setIsPopupOpen(true);
  };

  const columns = useMemo(
    () => [
      {Header: 'Patient ID', accessor: 'p_uhid'},
      {Header: 'Patient Name', accessor: 'patient'},
      {
        Header: 'Procedure',
        accessor: 'procedure',
        Cell: ({value}) => {
          const procedureName = procedures.find(p => p.name === value)?.name || 'Unknown';
          return procedureName;
        }
      },
      {
        Header: 'Hospital Detail',
        accessor: 'hospital',
        Cell: ({value}) => {
          const hospitalName = hospitals.find(h => h.name === value)?.name || 'Unknown';
          return hospitalName;
        }
      },
      {
        Header: 'Date',
        accessor: 'admission_date',
        Cell: ({value}) => {
          const formattedDate = formatDate(value);
          return (
            <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={formattedDate}>
              {formattedDate}
            </div>
          );
        }
      },
      {
        Header: 'Time',
        accessor: 'time',
        Cell: ({row}) => {
          const time = formatTime(row.original.admission_date);
          return (
            <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(time)}>
              {String(time)}
            </div>
          );
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({value}) => {
          const getStatusColor = status => {
            switch (status) {
              case 'Pending':
                return 'warning';
              case 'Completed':
                return 'success';
              case 'Cancelled':
                return 'error';
              default:
                return 'default';
            }
          };

          if (value === 'cancel') {
            value = 'Cancelled';
          } else if (value === 'complete') {
            value = 'Completed';
          } else if (value === 'pending') {
            value = 'Pending';
          }
          return (
            <Chip
              label={value}
              color={getStatusColor(value)}
              // variant="outlined"
              size='small'
              sx={{
                height: '20px', // Reduce overall height
                padding: '0 6px', // Adjust padding
                '& .MuiChip-label': {
                  fontSize: '0.75rem', // Reduce text size
                  padding: '0 4px' // Adjust inner padding
                }
              }}
            />
          );
        }
      },

      {
        Header: 'Actions',
        accessor: 'id',
        Cell: ({row}) => {
          if (!row.original || Object.keys(row.original).length === 0) {
            return <span>No Data</span>;
          }
          return <Actions data={row.original} setEditData={setEditData} setIsPopupOpen={setIsPopupOpen} />;
        }
      }
    ],
    [hospitals, procedures, isPopupOpen]
  );

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      {isPopupOpen && (
        <AddPatientScheule
          setCloseCreatePopup={setIsPopupOpen}
          loaderchange={loaderchange}
          popupalert={popupalert}
          popuptext={popuptext}
          editData={editData} // Pass edit data
          procedures={procedures}
          hospitals={hospitals}
          pagination={pagination}
        />
      )}

      {Array.isArray(inpatient?.data) && inpatient.data.length > 0 && <PageHeader title='Inpatient Schedule' cb={handleCreateDrugInventory} tableData={inpatient.data} type='inpatient' />}

      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <Filters filters={filters} setFilters={setFilters} setPagination={setPagination} />
                  {Array.isArray(inpatient?.data) && inpatient.data.length > 0 && (
                    <InPatientTable data={inpatient.data} columns={columns} pagination={pagination} setPagination={setPagination} datacount={dataCount} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InPatientSchedule;
